var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.mode == "edit"
      ? _c(
          "div",
          { staticClass: "rich-text-container" },
          [
            _c("RichText", {
              staticClass: "custom-richtext",
              attrs: { options: _vm.optionsRichText },
              model: {
                value: _vm.content,
                callback: function($$v) {
                  _vm.content = $$v
                },
                expression: "content"
              }
            })
          ],
          1
        )
      : _c("div", {
          staticClass: "rich-text-style",
          domProps: {
            innerHTML: _vm._s(_vm.addBrToEmptyParagraphs(_vm.content))
          }
        })
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }